import { GiftCardsApiClient } from '@fourthwall/services/dist/GiftCardsApiClient'
import { type UseInfiniteQueryOptions, useInfiniteQuery } from '@tanstack/react-query'

const PAGE_SIZE = 20

type GetGiftCards = Parameters<typeof GiftCardsApiClient.getGiftCards>[0]
type GetGiftCardsResponse = Awaited<ReturnType<typeof GiftCardsApiClient.getGiftCards>>['data']

export const useGiftCardsInfiniteQuery = (
  params?: GetGiftCards,
  options?: UseInfiniteQueryOptions<GetGiftCardsResponse>,
) => {
  const query = useInfiniteQuery<GetGiftCardsResponse>(
    ['giftCardsInfinite', params],
    async ({ pageParam = 0 }) => {
      const { data } = await GiftCardsApiClient.getGiftCards({
        page: pageParam,
        size: PAGE_SIZE,
        ...params,
      })

      return data
    },
    {
      getNextPageParam: ({ page: { hasNextPage, pageNumber } }) => hasNextPage && pageNumber + 1,
      keepPreviousData: true,
      ...options,
    },
  )

  return { query }
}
